<div class="px-8 py-10 md:py-12 xl:py-14 text-center">
  @if (textByTextCardData.text) {
    <div
      class="pb-6 md:px-80"
      [innerHTML]="textByTextCardData.text"
      [ssDirectus]="{
        collection: 'textByTextCard',
        item: textByTextCardData.id,
        fields: ['text'],
      }"
    ></div>
  }
  <div
    class="flex flex-col items-center justify-center md:flex-row gap-4 md:gap-5"
  >
    <div
      class="pr-4 md:pr-0 max-w-xs"
      [innerHTML]="textByTextCardData.textLeft"
      [ssDirectus]="{
        collection: 'textByTextCard',
        item: textByTextCardData.id,
        fields: ['textLeft'],
      }"
    ></div>
    <div
      class="border-y-4 border-ss-gold py-8 md:px-8 max-w-xs md:border-x-4 md:border-y-0 md:px-0"
      [innerHTML]="textByTextCardData.textCenter"
      [ssDirectus]="{
        collection: 'textByTextCard',
        item: textByTextCardData.id,
        fields: ['textCenter'],
      }"
    ></div>
    <div
      class="pl-4 max-w-xs md:pl-0"
      [innerHTML]="textByTextCardData.textRight"
      [ssDirectus]="{
        collection: 'textByTextCard',
        item: textByTextCardData.id,
        fields: ['textRight'],
      }"
    ></div>
  </div>
</div>
